import { normalizeSensorPlacementResponse } from "../components/utility/sensorPlacement";
import { endpoints } from "./endpoints";
import { authedGet } from "./http";

export const fetchSensorPlacementByZone = async (projectId, zone) => {
  const { data } = await authedGet(
    endpoints.apps.sensorPlacementByZone(projectId, zone),
  );
  return normalizeSensorPlacementResponse(data);
};

export const fetchSensorPlacementByScenario = async (projectId, scenario) => {
  const { data } = await authedGet(
    endpoints.apps.sensorPlacementByScenario(projectId, scenario),
  );
  return normalizeSensorPlacementResponse(data);
};

export const fetchSensorPlacementForZones = async (projectId, zones = []) => {
  const results = await Promise.all(
    zones.map(async (zone) => ({
      key: zone,
      data: await fetchSensorPlacementByZone(projectId, zone),
    })),
  );
  return Object.fromEntries(results.map(({ key, data }) => [key, data]));
};

export const fetchSensorPlacementForScenarios = async (
  projectId,
  scenarios = [],
) => {
  const results = await Promise.all(
    scenarios.map(async (scenario) => ({
      key: scenario,
      data: await fetchSensorPlacementByScenario(projectId, scenario),
    })),
  );
  return Object.fromEntries(results.map(({ key, data }) => [key, data]));
};
